import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function requiredWithUsername(username: string | null): ValidatorFn {
  return (control: AbstractControl): ValidationErrors => {
    let comment = control.value?.trim() ?? '';
    const hasUsername = username !== null ? comment.startsWith(username) : false;

    if (hasUsername) {
      comment = comment.substring(username.length).trim();
    }

    if (comment === '') {
      return { requiredWithUsername: true };
    }

    return null;
  }
}
